/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsLinksOptions, FxIdDomainSettingsLinksOptionsFromJSONTyped, FxIdDomainSettingsLinksOptionsToJSON, } from './FxIdDomainSettingsLinksOptions';
export function FxIdDomainSettingsPublicWebClientConfigOptionsLinksFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLinksFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLinksFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsLinksOptions(json)) {
        return FxIdDomainSettingsLinksOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLinksToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLinksToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLinksToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsLinksOptions(value)) {
        return FxIdDomainSettingsLinksOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsLinks.js.map